// src/components/atoms/HomePageUserHeader.js

import React from "react";
import { Typography, Box } from "@mui/material";

const HomePageUserHeader = ({ currentUser }) => {
  // Extract the first name if user is authenticated
  const cleanedDisplayName = currentUser.displayName
    .trim()
    .replace(/\s+/g, " ");
  const firstName = cleanedDisplayName.split(" ")[0];

  return (
    <>
      {/* Header */}
      <Box
        sx={{
          padding: 4,
          paddingBottom: 0,
          m: {
            sx: 1,
            sm: 2,
            md: 4,
            lg: 4,
            xl: 4,
          },
          mt: 0,
          ml: 0,
          mb: {
            sx: 2,
            sm: 4,
            md: 8,
            lg: 8,
            xl: 8,
          },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "basic-sans",
            fontWeight: "normal",
            fontSize: {
              xs: "1.5em", // Font size for mobile devices
              sm: "1.5em", // Font size for small tablets
              md: "1em", // Font size for tablets
              lg: "1.7em", // Font size for desktop
              xl: "2.0em", // Font size for larger screens
            },
          }}
        >
          {currentUser ? (
            <>
              Welcome back,{" "}
              <Box
                component="span"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "basic-sans",
                }}
              >
                {firstName}
              </Box>
              !
            </>
          ) : (
            "Welcome to Kbean Challenges!"
          )}
        </Typography>
      </Box>
    </>
  );
};

export default HomePageUserHeader;
